import types from "../types";
import buildRSA from "./buildRSA";
import queryString from "query-string";

export const getDiscussions = (query = {}, previousData = []) => {
  const _query = queryString.stringify(query);
  return buildRSA(
    {
      endpoint: `/discussions?${_query}`,
      method: "GET",
      types: [
        types.DO_GET_DISCUSSIONS_DATA,
        types.SET_GET_DISCUSSIONS_DATA,
        types.SET_GET_DISCUSSIONS_ERROR
      ]
    },
    true,
    false,
    json => {
      json.data = previousData.concat(json.data);
      return json;
    }
  );
};

export const updateDiscussion = (discussionId, data) =>
  buildRSA(
    {
      endpoint: `/discussions/${discussionId}`,
      method: "PATCH",
      types: [
        types.DO_PATCH_DISCUSSION,
        types.SET_PATCH_DISCUSSION_DATA,
        types.SET_PATCH_DISCUSSION_ERROR
      ],
      body: data
    },
    true,
    false
  );

export const deleteDiscussion = discussionId =>
  buildRSA(
    {
      endpoint: `/discussions/${discussionId}`,
      method: "DELETE",
      types: [
        types.DO_DELETE_DISCUSSION,
        types.SET_DELETE_DISCUSSION_DATA,
        types.SET_DELETE_DISCUSSION_ERROR
      ]
    },
    true,
    false
  );

export default {
  getDiscussions,
  updateDiscussion,
  deleteDiscussion
};
